document.addEventListener("DOMContentLoaded", function () {
  const bannerContainer = document.querySelector(".dropdown-banner__container");
  const button = document.querySelector(".dropdown-banner__button");
  const content = document.querySelector(".dropdown-banner__content");
  const closeButton = document.querySelector(".dropdown-banner__close");
  const homepageBanner = document.querySelector(".hompage-banner__wrapper");

  if (!button || !content || !bannerContainer) return;

  function showBanner() {
    bannerContainer.style.display = "block";
    bannerContainer.offsetHeight; // Force reflow

    bannerContainer.classList.add("show");
    bannerContainer.classList.remove("hide");

    if (homepageBanner) {
      homepageBanner.style.transform = "translateY(0)";
      homepageBanner.classList.remove("banner-closed");
    }
  }

  function hideBanner() {
    bannerContainer.classList.remove("show");
    bannerContainer.classList.add("hide");

    if (homepageBanner) {
      homepageBanner.style.transform = `translateY(0px)`;
      homepageBanner.classList.add("banner-closed");
    }

    setTimeout(() => {
      bannerContainer.style.display = "none";
    }, 300);
  }

  // Initialize: Set proper height when content is closed
  content.style.maxHeight = "0";

  // Handle expand/collapse
  button.addEventListener("click", function () {
    const isExpanded = button.getAttribute("aria-expanded") === "true";
    button.setAttribute("aria-expanded", !isExpanded);

    if (isExpanded) {
      content.style.maxHeight = "0";
      content.setAttribute("hidden", "");
    } else {
      content.removeAttribute("hidden");
      content.style.maxHeight = content.scrollHeight + "px";
    }
  });

  // Handle close button with cookie
  closeButton.addEventListener("click", () => {
    hideBanner();
    document.cookie = "subscribeDismissed=true; expires=" + new Date(new Date().getTime() + 24 * 60 * 60 * 1000).toUTCString() + "; path=/";
  });

  // Check for cookie on page load and apply appropriate classes
  if (document.cookie.indexOf("subscribeDismissed=true") !== -1) {
    bannerContainer.style.display = "none";
    if (homepageBanner) {
      homepageBanner.classList.add("banner-closed");
      homepageBanner.style.transform = `translateY(0px)`;
    }
  } else {
    showBanner();
    if (homepageBanner) {
      homepageBanner.classList.remove("banner-closed");
    }
  }
});